export default {
    name: 'TapToPay',
    dimensions: { width: 32, height: 40 },
    content: `
    <svg fill="none">
    <g clip-path="url(#clip0_12_2656)">
    <mask id="mask0_12_2656" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-4" y="23" width="40" height="17">
    <rect x="-4" y="23" width="40" height="17" fill="currentColor"/>
    </mask>
    <g mask="url(#mask0_12_2656)">
    <rect x="5" y="16" width="22" height="38" rx="3" stroke="currentColor" stroke-width="2"/>
    <path d="M13 32.2857L14.8 34L19 30" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <path d="M23 4H28C29.6569 4 31 5.34315 31 7V21C31 22.6569 29.6569 24 28 24H4C2.34315 24 1 22.6569 1 21V7C1 5.34315 2.34315 4 4 4H9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <rect x="23" y="12" width="4" height="4" rx="1" stroke="currentColor" stroke-width="2"/>
    <path d="M13 6L16 9L19 6" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16 9L16 1" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_12_2656">
    <rect width="32" height="40" fill="none"/>
    </clipPath>
    </defs>
    </svg>
  `
};
